<template>
  <div class="invoice-mgr">
    <ContentBlock style="padding: 0 10px 84px 10px;">
      <div class="topTitleContainer">
        <div class="flex-item">发货状态
          <el-radio-group v-model="outform.status" @change="getList('init')" style="margin-left: 14px;">
            <el-radio-button v-for="i in executionStatusGroup" :label="i.value" :key="i.value">{{`${i.label}(${i.count || 0})`}}</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <expand-table
        class="content_block"
        ref="expandTable"
        :toolBar="toolBar"
        :showRightToolbar="true"
        :columnList="orderTableColumns"
        :tableData="dataList"
        :expandConfig="expandConfig"
        :pagination.sync="pagination"
        :sortInfo.sync="updateSortInfo"
        @size-change="getList"
        @current-change="getList"
        @sort-change="getList"
        @handleToggleRowExpand="handleToggleRowExpand"
        style="padding: 0;"
      />
    </ContentBlock>
    <el-drawer title="高级筛选" width="400" direction="rtl" :modal-append-to-body="false" :visible.sync="isShow"
      :close-on-click-modal="false" @closed="isShow = false">
      <el-form label-width="auto" label-position="right" style="margin-top: 20px;padding: 10px;">
        <el-row>
          <el-col :span='24'>
            <el-form-item label="销售订单号">
              <el-input
                v-model.trim="outform.orderCode"
                clearable
                placeholder="请输入销售订单号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="销售合同号">
              <el-input
                v-model.trim="form.contractCode"
                clearable
                placeholder="请输入销售合同号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="收货人">
              <el-input
                v-model.trim="form.receiverName"
                clearable
                placeholder="请输入收货人"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center;">
        <el-button @click="handleEmpty">清空</el-button>
        <el-button type="primary" @click="getList('init')">查询</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { TablePaginationMixin } from '@/components/common/TableWithPagination';
import ExpandTable from '@/components/common/ExpandTable';
import { queryPage, queryStateInfo } from '@/api/invoiceMgr';
import { executionStatusGroup } from '@/model/invoiceMgr';
import { setOrderTableColumns } from './config/index';

export default {
  name: 'InvoiceMgr',
  mixins: [TablePaginationMixin],
  components: {
    ExpandTable,
  },
  computed: {
    toolBar () {
      let currentLists = [
        {
          type: 'custom',
          render: () => {
            return (
              <el-input placeholder='请输入销售单号' style='width:250px;' v-model={this.outform.orderCode}>
                <el-button slot="suffix" icon="el-icon-search" onClick={this.handleSearch} style='position: absolute;height: 100%;right: -5px;top: 0;'>
                </el-button>
              </el-input>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            const icAdvanceSearch = require('@/assets/table/ic_advanceSearch.svg'); // eslint-disable-line
            return (
              <vxe-button circle onClick={this.handleAdvancedSearch}>
                <img style='font-size:14px;width:15px;height:15px;' src={icAdvanceSearch} />
              </vxe-button>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            const icRefresh = require('@/assets/table/ic_refresh.svg'); // eslint-disable-line
            return (
              <vxe-button circle onClick={this.handleReset}>
                <img style='font-size:14px;width:15px;height:15px;' src={icRefresh} />
              </vxe-button>
            );
          },
        },
      ];
      return currentLists;
    },
    orderTableColumns () {
      return setOrderTableColumns.call(this);
    },
  },
  data () {
    return {
      outform: {
        status: '',
        orderCode: '',
      },
      isShow: false,
      isExpand: 1,
      expandConfig: {
        accordion: false,
        lazy: false,
        expandAll: true,
        reserve: true,
      },
      dataList: [],
      form: {
        contractCode: '',
        receiverName: '',
      },
      executionStatusGroup,
      scrollHeight: 600,
      isFullScreen: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  async created () {
    this.getList();
    this.getCount();
  },
  methods: {
    handleSearch () {
      this.pagination.currentPage = 1;
      this.getList();
    },
    handleAdvancedSearch () {
      this.isShow = true;
    },
    handleToggleExpand () {
      this.isExpand = this.isExpand === 3 ? 1 : 3;
      this.$nextTick(() => {
        this.$refs.expandTable.$refs.vxeTable.setAllRowExpand(this.isExpand === 1);
      });
    },
    handleToggleRowExpand () {
      let records = this.$refs.expandTable.$refs.vxeTable.getRowExpandRecords();
      if (records && records.length) {
        this.isExpand = records.length === this.dataList.length ? 1 : 2;
      } else {
        this.isExpand = 3;
      }
    },
    handleEmpty () {
      this.form = this.$options.data().form;
      this.outform = this.$options.data().outform;
      this.pagination.currentPage = 1;
    },
    handleReset () {
      this.handleEmpty();
      this.pagination = {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      };

      this.getList();
    },
    handleSizeChange (_, size) {
      this.pagination.pageSize = size;
      this.getList();
    },
    handleNumChange (num) {
      this.pagination.currentPage = num;
      this.getList();
    },
    expandedOneRow (_, rec) {
      this.$nextTick(() => {
        setTimeout(() => {
          const subtbs = document.querySelectorAll('.subTable');
          const elements = document.querySelectorAll(`[data-row-key='${rec.id}-extra-row']`);
          const length = elements.length;
          const height = elements[0].offsetHeight - 18.6;

          for (let i = 0; i < subtbs.length; i++) {
            subtbs[i].style.paddingRight = 200 + 'px';
          }

          elements[length - 1].childNodes[0].innerHTML = `<div style='height: ${height}px;'></div>`;
        }, 0);
      });
    },
    getList (type) {
      if (type === 'init') {
        this.pagination.total = 0;
        this.pagination = {
          currentPage: 1,
          pageSize: 10,
        };
      }

      let orderBy = [
        {
          orderByProperty: 'lastUpdateTime',
          orderByType: 'DESC',
        },
      ];

      const page = {
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };

      this.isShow = false;

      queryPage({
        ...this.form,
        ...this.outform,
        excludeDockingSystem: 'XIAOZI_ERP',
        findDeliveryGoodsFlag: true,
        findLogisticsFlag: true,
        findOrderFlag: true,
        orderBy,
        ...page,
      }).then(({ body }) => {
        const data = (body.list || []).map(v => {
          v.deliveryGoodsList.map(item => {
            item.dockingSystem = v.dockingSystem;
          });
          return v;
        });
        this.dataList = data;
        this.pagination.total = +body.total || 0;
      });
    },
    getCount () {
      queryStateInfo({excludeDockingSystem: 'XIAOZI_ERP'}).then(({ body }) => {
        for (let v of this.executionStatusGroup) {
          v.count = body[v.en];
        }
        const allCount = body.deliveryCount + body.cancelCount;
        this.executionStatusGroup[0].count = allCount;
      });
    },
    handleDetail (row) {
      this.$router.push({
        path: '/saas/invoiceMgr/detail',
        query: {
          id: row.id,
          arrivalCode: row.code,
          orderId: row.orderId,
          orderCode: row.orderCode,
          arrivalSts: row.status,
          unit: row.customerName,
          tenantId: row.tenantId,
        },
      });
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/ .topTitleContainer {
  min-height: 60px;
  background: #FFFFFF;
  box-shadow: inset 0px -1px 0px 0px #DFE2E8;
  border-radius: 6px 6px 0px 0px;
  // display: flex;
  // align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #606266;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  padding: 10px;
  .flex-item {
    display: flex;
    align-items: center;
  }
}

/deep/.vxe-tools--wrapper {
  display: flex;
  justify-content: space-between;

  &>.el-button {
    margin-left: 0.5em;
  }

  &>div.el-input {
    margin-left: 0.5em;
  }

  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .vxe-tools--operate {
  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .action {
  color: #409EFF;
  cursor: pointer;

  &:hover {
    color: rgba(64, 158, 255, 0.7);
    text-decoration: underline;
  }
}
</style>
